import { makeRequest } from 'cityads-v3/utils/apiUtils';

export const TOGGLE_MENU = "menu/TOGGLE_MENU";
export const ONLOAD_GET_SHOW_MENU_SETTING = "menu/ONLOAD_GET_SHOW_MENU_SETTING";
export const SET_VISIBLE = "menu/SET_VISIBLE";

export const GET_LAYOUT_DATA = "menu/GET_LAYOUT_DATA";
export const GET_LAYOUT_DATA_SUCCESS = "menu/GET_LAYOUT_DATA_SUCCESS";
export const GET_LAYOUT_DATA_FAIL = "menu/GET_LAYOUT_DATA_FAIL";

export function toggleMenu(opened, docked = false) {
  return {
    type: TOGGLE_MENU,
    opened,
    docked
  }
}

export function onLoadGetShowMenuSetting() {
  return {
    type: ONLOAD_GET_SHOW_MENU_SETTING
  }
}

export function setVisible(isVisible) {
  return {
    type: SET_VISIBLE,
    isVisible,
  }
}

export function getLayoutData() {
  return makeRequest('/saduka/auth/layoutData', {
    types: [GET_LAYOUT_DATA, GET_LAYOUT_DATA_SUCCESS, GET_LAYOUT_DATA_FAIL],
    options: {
      credentials: 'include'
    },
  });
}
